import { XMarkIcon } from '@heroicons/react/16/solid';
import { Avatar, Button, Modal } from 'react-daisyui';

// Own components
import EditUserForm from './EditUser.form.tsx';
import { useTeamContext } from '../../../Team.context.ts';
import { GetInitialsName } from '../../../../../../../utils/GetInitialsName.ts';

export default function ManageWorkspaceUser() {
  const { toggleEditUserModal, showEditUserModal, userToEdit, setUserToEdit } =
    useTeamContext();

  return (
    <Modal
      open={showEditUserModal}
      className="EditUserModal"
      backdrop={true}
      responsive={true}
    >
      <Modal.Header className="TeamSection__Modal__Header">
        <div className="TeamSection__Modal__Avatar">
          <Avatar
            letters={GetInitialsName(userToEdit?.name ?? '')}
            src={userToEdit?.profilePicture ?? ''}
            size="xs"
            shape="circle"
            color="primary"
          />
          <div className="TeamSection__Modal__Avatar__Content">
            <p className="TeamSection__Modal__Avatar__Name">
              {userToEdit?.name}
            </p>
            <p className="TeamSection__Modal__Avatar__Email">
              {userToEdit?.email}
            </p>
          </div>
        </div>
        <Button
          color="ghost"
          size="sm"
          shape="square"
          onClick={() => {
            setUserToEdit(null);
            toggleEditUserModal(false);
          }}
        >
          <XMarkIcon className="TeamSection__Modal__CloseIcon" />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <EditUserForm />
      </Modal.Body>
    </Modal>
  );
}
